import { DecisionTreeInput } from '@/components/decision-tree/components/SurveyItem/components/Question/components/DecisionTreeInput';
import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { Box, InlineAlert } from '@cmpsr/components';
import { FC } from 'react';
import useNumericController from './Numeric.controller';
import { NumericAnswer, NumericProps } from './types';
export const Numeric: FC<NumericProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { label, id, placeholder, trailingMask, whyWeAskExplanation, tooltip, description, validationValues } = data;
  const { form, onInputFn, validationOptions, onBlurFn, enterKeyHandler } = useNumericController({
    trailingMask,
    validationValues,
    saveAnswer,
    defaultValue,
  });

  return (
    <Box as="form" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Box margin="auto" mt={6}>
        <DecisionTreeInput
          trailingMask={trailingMask ?? ''}
          key={id}
          questionId={id}
          variant="outline"
          placeholder={placeholder ?? ''}
          defaultValue={(defaultValue as NumericAnswer)?.value ?? ''}
          borderColor={
            form.formState.errors.number?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
          }
          {...form.register('number', validationOptions)}
          onInput={onInputFn}
          onBlur={onBlurFn}
          onKeyDown={enterKeyHandler}
          autoFocus
        />
        {form.formState.errors.number?.message ? (
          <InlineAlert status="error" mt="spacer-6" alignItems="flex-start">
            <InlineAlert.Icon />
            <InlineAlert.Message>{form.formState.errors.number?.message}</InlineAlert.Message>
          </InlineAlert>
        ) : null}
      </Box>
    </Box>
  );
};
